module.exports = __webpack_public_path__ + "img/superlever-cardIcon1.032833d3.svg";